export default "__VITE_ASSET__DBoQKEL1__"